export default __webpack_public_path__ + "static/media/9988.2486fda8.png";